export default "/images/sonderjysk-cropped.webp?b476706630a0ffa1e86a13c3a48c5c27";